import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BookingComponent } from "./booking.component";
import { ApiResourceModule } from "libraries/service/apiResource/apiResource.module";
import { ResourceModule } from "libraries/service/resource/resource.module";
import { PipesModule } from "libraries/pipes/pipes.module";
import { SegmentModule } from "libraries/segment/segment.module";
import { PriceDifferenceModule } from "libraries/price-difference/price-difference.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { PricePipesModule } from "libraries/pipes/price/price-pipes.module";
import { PricePipeModule } from "libraries/pipes/price/price-pipe.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { SectorModule } from "libraries/service/sector/sector.module";
import { DatePipeModule } from "libraries/date/date.module";
import { FlightDetailsModule } from "app_locobook/shared/flight-details/flight-details.module";
import { AirTripResourceModule } from "libraries/service/resources/airTrip/airTripResource.module";
import { MatDialogModule } from "@angular/material/dialog";
import { TextExportDialogModule } from "libraries/component/dialogs/text-export-dialog/text-export-dialog.module";
import { PriceService } from "app_locobook/service/price.service";
import { PriceTableModule } from "libraries/component/booking-information/components/booking-price-card/components/shared/components/price-table/price-table.module";
import { DatatablePriceModule } from "libraries/datatable-price/datatable-price.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { CardModule } from "libraries/ui_card/card.module";
import { MenuDetailsModule } from "libraries/hotel/components/menu-details/menu-details.module";
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { ClickStopModule } from "libraries/directive/clickstop/click-stop.module";
import { GetDataForSelectionModule } from "libraries/pipes/get-data-for-selection/get-data-for-selection.module";
import { CarbonFootprintModule } from "libraries/component/carbon-footprint/carbon-footprint.module";
import { YucangooRatingModule } from "libraries/component/yucangoo-rating/yucangoo-rating.module";
import { RatingTableModule } from "libraries/component/rating-table/rating-table.module";
import { YucangooModule } from "app_locobook/shared/yucangoo/yucangoo.module";
import { LanguageService } from "libraries/service/language/language.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PropalModule } from "app_locobook/service/propal/propal.module";
import { BookingPriceCardServiceModule } from "libraries/component/booking-information/components/booking-price-card/booking-price-card-service.module";
import { ActionQualityHelperModule } from "libraries/service/action-quality-helper/action-quality-helper.module";
import { ExchangeModule } from "app_locobook/shared/exchange/exchange.module";
import { ErrorTracingModule } from "libraries/service/error-tracing/error-tracing.module";
import { IsFaretypePipe } from "app_locobook/shared/booking/is-faretype.pipe";
import { TabNavigationModule } from "libraries/component/tab-navigation/tab-navigation.module";
import { InterfaceFlagModule } from "libraries/component/interface-flag/interface-flag.module";

@NgModule({
    imports: [
        ActionQualityHelperModule,
        AirTripResourceModule,
        ApiResourceModule,
        BookingPriceCardServiceModule,
        BtnModule,
        CarbonFootprintModule,
        CardModule,
        ClickStopModule,
        ClickStopModule,
        CommonModule,
        DatatablePriceModule,
        DatePipeModule,
        DatePipeModule,
        ErrorTracingModule,
        ExchangeModule,
        FlightDetailsModule,
        FontAwesomeModule,
        GetDataForSelectionModule,
        HostAliasPipeModule,
        InterfaceFlagModule,
        LoaderModule,
        MatDialogModule,
        MenuDetailsModule,
        NotificationModule,
        PermissionModule,
        PipesModule,
        PriceDifferenceModule,
        PricePipeModule,
        PricePipesModule,
        PriceTableModule,
        PropalModule,
        RatingTableModule,
        ResourceModule,
        SectorModule,
        SegmentModule,
        TabNavigationModule,
        TextExportDialogModule,
        YucangooModule,
        YucangooRatingModule,
    ],
    declarations: [
        BookingComponent,
        IsFaretypePipe,
    ],
    exports: [
        BookingComponent,
    ],
    providers: [
        LanguageService,
        PriceService,
    ]
})
export class BookingModule {
}
